module.exports = __webpack_public_path__ + "static/media/placeholder.bfc6b305.jpg";